import { urlValidator } from "./validators";

export const handleLinkClick = (data) => {
  if (data.url?.source === "email") {
    window.location.href = `mailto:${data.url?.link}`;
  }

  if (data.url?.source === "direct" || data.url?.source === "page") {
    const isValidUrl = urlValidator({
      url: data.url?.link,
      protocols: ["https:"],
    });

    if (isValidUrl) {
      window.open(data.url?.link, data.newTab ? "_blank" : "_top");
    }
  }
};
